import { View } from 'backbone.marionette';
import Backbone from 'backbone';
import Backgrid from 'backgrid';
import _ from 'lodash';

import GridView from '@/views/GridView';

import OrderDeviceCollectionView from '../OrderDeviceCollectionView';
import OrderDeviceAdminCollectionView from '../OrderDeviceAdminCollectionView';

import tmplVB0v3DeviceSectionView from './VB0v3DeviceSectionView.hbs';

import './VB0v3DeviceSectionView.css';

const VB0v3DeviceSectionView = View.extend({
  template: tmplVB0v3DeviceSectionView,

  className: 'vb0-v3-device-section-view',

  ui: {
    matrixGrid: '.matrix-grid',
    optionalCollection: '.optional-collection',
    toggle: '.toggle'
  },

  regions: {
    matrixGrid: '.matrix-grid',
    optionalCollection: '@ui.optionalCollection'
  },

  events: {
    'click @ui.toggle': 'onClickToggle'
  },

  collection: null,

  onClickToggle() {
    const id = this.model.get('id').concat('-caret');
    const caret = document.getElementById(id);
    if (caret.classList.contains('fa-caret-down')) {
      caret.classList.remove('fa-caret-down');
      caret.classList.add('fa-caret-up');
    } else if (caret.classList.contains('fa-caret-up')) {
      caret.classList.remove('fa-caret-up');
      caret.classList.add('fa-caret-down');
    }
  },

  onBeforeRender() {
    if (this.model.get('type') === 'devices') {
      const volumeBands = _.groupBy(this.model.get('lineItems'), 'volumeBand');
      this.model.set('volumeBands', volumeBands);
    } else {
      const optionalItemCategories = _.groupBy(this.model.get('lineItems'), 'compatibleDeviceKey');
      this.model.set('optionalItemCategories', optionalItemCategories);
    }
  },
  renderMatrixGrid() {
    const checkMarkCell = Backgrid.Cell.extend({
      render() {
        const isPrinterNIPR = this.model.get('isPrinterNIPR') === 'true';
        const isPrinterSIPR = this.model.get('isPrinterSIPR') === 'true';
        const isMFDNIPR = this.model.get('isMFDNIPR') === 'true';
        const isMFDSIPR = this.model.get('isMFDSIPR') === 'true';
        const isScanner = this.model.get('isScanner') === 'true';
        const col = this.column.get('name');

        switch (col) {
          case 'isPrinterNIPR':
            isPrinterNIPR && this.template();
            break;
          case 'isPrinterSIPR':
            isPrinterSIPR && this.template();
            break;
          case 'isMFDNIPR':
            isMFDNIPR && this.template();
            break;
          case 'isMFDSIPR':
            isMFDSIPR && this.template();
            break;
          case 'isScanner':
            isScanner && this.template();
            break;
        }
        return this;
      },

      template() {
        this.$el.html('<i class="fa fa-check"></i>');
      }
    });

    if (this.model.get('deviceMatrix')) {
      this.columns = [
        {
          name: 'description',
          label: 'Description',
          cell: 'String',
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'isPrinterNIPR',
          label: 'Printer (NIPR)',
          cell: checkMarkCell,
          headerCell: 'custom',
          width: 3,
          sortable: false
        },
        {
          name: 'isPrinterSIPR',
          label: 'Printer (SIPR)',
          cell: checkMarkCell,
          headerCell: 'custom',
          width: 3,
          editable: false,
          sortable: false
        },
        {
          name: 'isMFDNIPR',
          label: 'MFD (NIPR)',
          cell: checkMarkCell,
          headerCell: 'custom',
          width: 3,
          editable: false,
          sortable: false
        },
        {
          name: 'isMFDSIPR',
          label: 'MFD (SIPR)',
          cell: checkMarkCell,
          headerCell: 'custom',
          width: 3,
          editable: false,
          sortable: false
        },
        {
          name: 'isScanner',
          label: 'Scanner',
          cell: checkMarkCell,
          headerCell: 'custom',
          width: 3,
          editable: false,
          sortable: false
        }
      ];

      this.matrixGridView = new GridView({
        model: this.model,
        collection: new Backbone.Collection(this.model.get('deviceMatrix')),
        columns: this.columns
      });
      this.showChildView('matrixGrid', this.matrixGridView);
    }
  },

  onRender() {
    if (this.model.get('deviceMatrix')?.length) {
      this.renderMatrixGrid();
    }
    this.collection = new Backbone.Collection(this.model.get('lineItems'));
    const regions = [];
    const volumeBands = this.model.get('volumeBands');
    const optionalItemCategories = this.model.get('optionalItemCategories');
    this.model.set('volumeBands', volumeBands);
    _.each(volumeBands, (volumeBand, key) => {
      const monoRegion = `${key}-mono-collection`.replace(/[^a-zA-Z0-9\-]/g, '');
      const colorRegion = `${key}-color-collection`.replace(/[^a-zA-Z0-9\-]/g, '');
      const mono = [];
      const color = [];
      _.each(volumeBand, (device) => {
        if (device.isColor === '1') {
          color.push(device);
        } else {
          mono.push(device);
        }
      });
      this.addRegion(monoRegion, `.${monoRegion}`);
      this.addRegion(colorRegion, `.${colorRegion}`);
      regions.push(monoRegion, colorRegion);

      this.collection.add(mono);
      this.collection.add(color);

      const monoId = `.${key}-mono`.replace(/[^a-zA-Z0-9\-]/g, '');
      const colorId = `.${key}-color`.replace(/[^a-zA-Z0-9\-]/g, '');
      if (mono.length) {
        if (this.model.get('isAdminEdit')) {
          this.showChildView(
            monoRegion,
            new OrderDeviceAdminCollectionView({
              collection: new Backbone.Collection(mono)
            })
          );
        } else {
          this.showChildView(
            monoRegion,
            new OrderDeviceCollectionView({
              collection: new Backbone.Collection(mono)
            })
          );
        }
      } else {
        this.$(monoId).remove();
        this.$(colorId).addClass('col-12').remove('col-6');
      }
      if (color.length) {
        if (this.model.get('isAdminEdit')) {
          this.showChildView(
            colorRegion,
            new OrderDeviceAdminCollectionView({
              collection: new Backbone.Collection(color)
            })
          );
        } else {
          this.showChildView(
            colorRegion,
            new OrderDeviceCollectionView({
              collection: new Backbone.Collection(color)
            })
          );
        }
      } else {
        this.$(colorId).remove();
        this.$(monoId).addClass('col-12').remove('col-6');
      }
    });

    _.each(optionalItemCategories, (category, key) => {
      const region = `${key}-collection`.replace(/[^a-zA-Z0-9\-]/g, '');
      this.addRegion(region, `.${region}`);
      regions.push(region);

      if (this.model.get('isAdminEdit')) {
        this.showChildView(
          region,
          new OrderDeviceAdminCollectionView({
            collection: new Backbone.Collection(category)
          })
        );
      } else {
        this.showChildView(
          region,
          new OrderDeviceCollectionView({
            collection: new Backbone.Collection(category)
          })
        );
      }
    });
    this.model.set('regions', regions);
    return;
  },

  getDeviceData() {
    const changedItems = [];
    const lineItems = this.model.get('lineItems');
    const regions = this.model.get('regions');
    let totalNiprMfdPrice = 0;
    let totalNiprMfdQuantity = 0;
    let totalSiprMfdPrice = 0;
    let totalSiprMfdQuantity = 0;
    let totalNiprPrinterPrice = 0;
    let totalNiprPrinterQuantity = 0;
    let totalSiprPrinterPrice = 0;
    let totalSiprPrinterQuantity = 0;
    let totalNiprScannerPrice = 0;
    let totalNiprScannerQuantity = 0;
    let totalTonerPrice = 0;
    let totalTonerQuantity = 0;
    let totalPaperTrayPrice = 0;
    let totalPaperTrayQuantity = 0;

    _.each(regions, (region) => {
      const collection = this.getChildView(region)?.collection;
      _.each(collection?.models, (model) => {
        const item = _.find(lineItems, { id: model.id });
        if (model.get('quantity') !== '0') {
          switch (model.get('panel')) {
            case 'NIPR_MFD':
              totalNiprMfdPrice += model.get('totalPrice');
              totalNiprMfdQuantity += parseInt(model.get('quantity'));
              break;
            case 'SIPR_MFD':
              totalSiprMfdPrice += model.get('totalPrice');
              totalSiprMfdQuantity += parseInt(model.get('quantity'));
              break;
            case 'NIPR_Printer':
              totalNiprPrinterPrice += model.get('totalPrice');
              totalNiprPrinterQuantity += parseInt(model.get('quantity'));
              break;
            case 'SIPR_Printer':
              totalSiprPrinterPrice += model.get('totalPrice');
              totalSiprPrinterQuantity += parseInt(model.get('quantity'));
              break;
            case 'NIPR_Scanner':
              totalNiprScannerPrice += model.get('totalPrice');
              totalNiprScannerQuantity += parseInt(model.get('quantity'));
              break;
            case 'Toner':
              totalTonerPrice += model.get('totalPrice');
              totalTonerQuantity += parseInt(model.get('quantity'));
              break;
            case 'Paper Tray':
              totalPaperTrayPrice += model.get('totalPrice');
              totalPaperTrayQuantity += parseInt(model.get('quantity'));
              break;
          }
        }
        if (model.get('quantity') !== item.quantity) {
          changedItems.push(model.attributes);
        }
      });
    });
    const savedData = {
      changedItems,
      totalNiprMfdPrice,
      totalNiprMfdQuantity,
      totalSiprMfdPrice,
      totalSiprMfdQuantity,
      totalNiprPrinterPrice,
      totalNiprPrinterQuantity,
      totalSiprPrinterPrice,
      totalSiprPrinterQuantity,
      totalNiprScannerPrice,
      totalNiprScannerQuantity,
      totalTonerPrice,
      totalTonerQuantity,
      totalPaperTrayPrice,
      totalPaperTrayQuantity
    };
    return savedData;
  }
});

export default VB0v3DeviceSectionView;
